
export enum GameAction {
    GameChatSubmit,
    SkippedWelcome,
    ClickedDice, SelectedTile, SelectedTiles, SelectedPlayer, PassedTurn, SelectedCards, SelectedCardsState,
    BuyDevelopmentCard,
    WantToBuildRoad, ConfirmBuildRoad, ConfirmBuildRoadSkippingSelection, ConfirmRemoveRoad,
    WantToBuildSettlement, ConfirmBuildSettlement, ConfirmBuildSettlementSkippingSelection,
    WantToBuildCity, ConfirmBuildCity, ConfirmBuildCitySkippingSelection,
    WantToBuildShip, ConfirmBuildShip, ConfirmBuildShipSkippingSelection,
    WantToMoveShip, SelectedShipToMove, ConfirmMoveShip,
    WantToBuildCityWall, ConfirmBuildCityWall, ConfirmBuildCityWallSkippingSelection,
    WantToPlaceKnight, ConfirmPlaceKnight, ConfirmPlaceKnightSkippingSelection,
    WantToUpgradeKnight, ConfirmUpgradeKnight, ConfirmUpgradeKnightSkippingSelection,
    WantToActivateKnight, ConfirmActivateKnight, ConfirmActivateKnightSkippingSelection,
    WantToTakeKnightAction, SelectKnightToTakeAction, ConfirmMoveKnight,
    ConfirmMoveKnightOffTurn, ConfirmRemoveKnight,
    ConfirmCityUpgrade, ConfirmBuildMetropolis,
    ConfirmPillageCity,
    ConfirmDicePair,
    CancelAction,
    ClickedDevelopmentCard,
    // trade
    CreateTrade, UpdateTradeResponse, ExecuteTrade, ToggledEmbargo,
    //
    RequestActionSwap,
    TogglePause, LeaveGame, Resign,
    // Special Build Phase
    RequestSpecialBuildPhase, CancelSpecialBuildPhase,
    ClickedRematch, Vote,
    Pong,
    RequestBeginnerHint, SkipWelcomeAction, RequestBeginnerModeLevelEnd,
    StressTestGracefulShutdown, SelectedInitialPlacementIndex,
    RequestGameState,
    NotifyBackendClientAutoReconnected, // Do not delete. Used for logging to track bugs in client reconnect. Has no other purpose

    ReportPlayer,
}

export interface GameActionClientData {
    action: GameAction
    payload: unknown
    sequence: number
}

export interface GameActionServerData {
    action: GameAction
    data: unknown
    sequence: number
}
